module.exports = __webpack_public_path__ + "static/media/tradebull-logo-large.cd5be8f9.png";